import { BottomTextLeft, BottomTextRight, CountText, HoursDaysMin, StyledButton, StyledCard, TimeFormat, Top, TopBar, TopSubText, TopText, } from './StylovyzeCard.styles';
import React from 'react';
import StylovyzeCardFooter from './StylovyzeCardFooter';
import { minutesToDaysHoursMinutes } from '@innovyze/stylovyze/lib/utils/timeFormatting';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
import { useConsumeWeaveTheme } from '../../hocs/ApplicationWrapper/theme/WeaveContext';
const FormatNumber = ({ count, format }) => {
    const { t } = useGlobalization();
    if (count && typeof count === 'number' && format === 'time') {
        const time = minutesToDaysHoursMinutes(count);
        const showDays = time.days > 0;
        const showHours = showDays || time.hours > 0;
        const showMins = showHours || time.minutes > 0;
        return (React.createElement(TimeFormat, null,
            showDays && (React.createElement(React.Fragment, null,
                React.createElement(HoursDaysMin, null, time.days),
                t('days', { count: time.days }))),
            showHours && (React.createElement(React.Fragment, null,
                React.createElement(HoursDaysMin, null, time.hours),
                t('hours', { count: time.hours }))),
            showMins && (React.createElement(React.Fragment, null,
                React.createElement(HoursDaysMin, null, time.minutes),
                t('minutes', { count: time.minutes })))));
    }
    return React.createElement(CountText, null, count ?? '-');
};
const StylovyzeCard = (props) => {
    const { resolvedRoles, isWeaveTheme } = useConsumeWeaveTheme();
    return (React.createElement(StyledCard
    // isWeaveTheme={isWeaveTheme}
    // resolvedRoles={resolvedRoles}
    , { 
        // isWeaveTheme={isWeaveTheme}
        // resolvedRoles={resolvedRoles}
        fullheight: props.fullHeight ?? false, height: props.height, "data-cy": props.dataCy, square: true },
        React.createElement(TopBar, { topcolor: props.topColor }),
        React.createElement(Top, { titleposition: props.titlePosition },
            React.createElement(FormatNumber, { count: props.countText, format: props.countFormat }),
            React.createElement(TopText, { height: undefined, titleposition: "above", aboveColor: isWeaveTheme
                    ? resolvedRoles['modal.fontColor']
                    : '#4a6067' }, props.topText),
            React.createElement(TopSubText, { titleposition: props.titlePosition, belowColor: isWeaveTheme
                    ? resolvedRoles['modal.fontColor']
                    : '#4a6067' }, props.topSubText),
            props.button && (React.createElement(StyledButton, { variant: "outlined", color: "primary", onClick: props.button.onClick, ...props.button.props },
                props.button.icon,
                " ",
                props.button.title))),
        (props.bottomTextLeft || props.bottomTextRight) && (React.createElement(StylovyzeCardFooter, null,
            React.createElement(BottomTextLeft, null, props.bottomTextLeft),
            React.createElement(BottomTextRight, null, props.bottomTextRight))),
        props.secondaryFooter));
};
StylovyzeCard.defaultProps = {
    topColor: '#007096',
    countFormat: 'number',
};
export default StylovyzeCard;
